import { Button } from "antd";
import styled from "styled-components";



export const StyledPrimaryButton = styled(Button)`
  
    &&.ant-btn-primary {
    background-color: #192238;
    border-color: #192238;
    color: white;
    border-radius: 0px;

    &:hover {
      background-color: white;
      border-color: #192238;
      color: #192238;
    }
    &:disabled {
      background-color: lightgray;
      border-color: lightgray;
      color: white;
    }
  }`

export const StyledBackButton = styled(Button)`
    width: 120px;
    margin-left: 30px;

    &:where(.css-dev-only-do-not-override-3mqfnx).ant-btn-default:not(:disabled):not(.ant-btn-disabled):hover {
    color: orange;
    border-color: orange
}
`